import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import {
  CreateReadyTemplateCommand,
  CustomResult,
} from 'src/app/core/api/models';
import { ReadyTemplatesService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { ConsoleService } from 'src/app/core/services/console.service';
import { BaseFormPageComponent } from 'src/app/pages/shared/base';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { ModalTitleComponent } from 'src/app/shared/global/modal-title/modal-title.component';

@Component({
  selector: 'app-ready-template-save-modal',
  templateUrl: './ready-template-save-modal.component.html',
  imports: [BaseFormModule, ModalTitleComponent],
})
export class ReadyTemplatesSaveModalComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties
  model: CreateReadyTemplateCommand = {};
  imageUrl: string;
  //#endregion

  constructor(
    protected currentService: ReadyTemplatesService,
    private dialogRef: MatDialogRef<ReadyTemplatesSaveModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.setFinalHtml(data);
    this.model.templateJs = data.jsCode;
    this.model.templateSass = data.cssCode;
  }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      title: new FormControl('', Validators.required),
      templatePreview: new FormControl(''),
      isPublicTemplate: new FormControl(''),
    });
  }

  setFinalHtml(data) {
    let htmlString = `<html><head><style>${data.cssCode} ${data.editorCssCode}</style></head>${data.htmlCode}<script>${data.jsCode}</script></html>`;
    htmlString = htmlString.replace(/[\n\r]/g, '');
    htmlString = htmlString.replace(/"/g, "'");
    this.model.templateHtml = htmlString;
  }

  //#region Api

  baseCreateApi(model) {
    this.unSubs();
    this.loading = true;
    this.currentService
      .readyTemplatesCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.dialogRef.close(true);
    this.unSubs();
  }

  baseObserver = {
    next: (result: CustomResult) => {
      this.apiNotificationService.notifyMessage({ result });
      if (result.isSucceed) {
        this.formPageConfig.isEditMode = false;
        this.onSuccess();
      } else this.onClose();
    },
    error: (error) => {
      ConsoleService.error('error', error);
    },
    complete: () => (this.loading = false),
  };

  getFile(file) {
    try {
      if (!file) {
        this.imageUrl = '';
        return;
      }
      this.onFileChanged(file);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  onFileChanged(file: any) {
    try {
      if (file && file) {
        this.form.controls['templatePreview'].setErrors(null);

        var reader = new FileReader();
        reader.onload = (event: any) => {
          this.imageUrl = event.target.result;
        };

        reader.readAsDataURL(file);
        this.handleFileSelect(file);
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  handleFileSelect(evt) {
    try {
      const files = evt;
      const file = files;

      if (files && file) {
        const reader = new FileReader();

        reader.onload = this._handleReaderLoaded.bind(this);

        reader.readAsBinaryString(file);
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  _handleReaderLoaded(readerEvt) {
    try {
      const binaryString = readerEvt.target.result;
      let stringImage = btoa(binaryString);
      this.model.templatePreview = 'data:image/png;base64,' + stringImage;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }
}
